import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const StoresSection = () => {
  const [stores, setStores] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const storesRef = collection(db, "Stores");
        const q = query(storesRef, orderBy("createdAt", "desc"));
        const snapshot = await getDocs(q);
        const storesData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setStores(storesData);
      } catch (err) {
        console.error("Error fetching stores:", err);
      }
    };

    fetchStores();
  }, []);

  return (
    <div className="bg-white m-3 rounded-lg py-6 px-4 md:px-12">
      <h2 className="text-xl md:text-3xl font-semibold text-gray-800 mb-4 text-left">
        Our Top Stores
      </h2>

      <div className="flex space-x-4 overflow-x-auto py-4 scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        {stores.length > 0 ? (
          stores.map((store) => (
            <div
              key={store.id}
              onClick={() => navigate(`/store/${store.id}`)}
              className="relative flex-shrink-0 w-48 h-60 sm:w-40 md:w-44 cursor-pointer rounded-lg overflow-hidden hover:scale-105 transition-transform"
            >
              <img
                src={store.imageUrl || store.image || "https://via.placeholder.com/150"}
                alt={store.name}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 w-full h-28 bg-gradient-to-t from-black/100 to-transparent flex flex-col justify-end p-3">
                <h3 className="text-base md:text-lg font-bold text-white">{store.name}</h3>
                <p className="text-xs md:text-sm text-white mt-1 line-clamp-2">{store.description}</p>
              </div>
            </div>
          ))
        ) : (
          <p className="text-gray-500">No stores added yet.</p>
        )}
      </div>
    </div>
  );
};

export default StoresSection;
